module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16WwpRP/images/e9781439632017_cover.jpg?1684515369535",
      "alt": "This image is the cover for the book Rye and Rye Beach, Postcard History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rye and Rye Beach, Postcard History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Although small, the town of Rye played a significant role in New Hampshire's history and in nineteenth-century lifestyle and recreation. From its beginnings in 1623, Rye was predominantly a farming and fishing community. In the years prior to the Civil War, however, local entrepreneurs recognized the potential of their seacoast location and began catering to the needs of wealthy Victorians seeking a temporary escape from urban living. These entrepreneurs exploited the restorative powers of the ocean and established boardinghouses and grand hotels that gained national recognition. By the 1890s, the Rye Beach area had peaked as a summer resort destination and began to evolve into a summer residence colony. Houses of grand scale and variety began to appear. Later, with the introduction of the automobile and the extension of cable-car systems up the coast, Rye and Rye Beach became more accessible for day trips to the ocean.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lewis T. Karabatsos\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lewis T. Karabatsos, a summer resident for more than twenty years, is an avid collector of Rye postcards, souvenir china, and other memorabilia. Working with members of the Rye Historical Society, he has compiled this unique look back at this town's prominent position as a leading seacoast community.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0